import { createFileRoute, redirect } from '@tanstack/react-router'

/** The DSU quota page lives under "Attività", where its box and its task are: an old link or email lands there. */
export const Route = createFileRoute(
	'/(private)/bando/$residenceId/quota-dsu/'
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: '/bando/$residenceId/attivita/quota-dsu',
			params,
			replace: true
		})
	}
})
